module.exports = __webpack_public_path__ + "static/img/200_TO8_2104_og.fd4e5cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/200_TO8_2104_og.jpg
// module id = 67tM
// module chunks = 0